import { render, staticRenderFns } from "./TablePhieuChi.vue?vue&type=template&id=0a77e784&scoped=true&"
import script from "./TablePhieuChi.vue?vue&type=script&lang=js&"
export * from "./TablePhieuChi.vue?vue&type=script&lang=js&"
import style0 from "./TablePhieuChi.vue?vue&type=style&index=0&id=0a77e784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a77e784",
  null
  
)

export default component.exports